import axios from "axios";

const { REACT_APP_VEHICLES_API } = process.env;

const { CancelToken } = axios;
const source = CancelToken.source();

export const getVehicleModels = async (
  customer,
  query = "",
  page,
  resultsPerPage,
  cancelToken = source.token,
  orderBy = "brand",
  order = "asc",
  filterBy = "",
) => {
  const url = `results_per_page=${resultsPerPage}&page=${page}&order_by=${orderBy}&order=${order}&q=${query}`;
  const params = new URLSearchParams(url);
  if (filterBy) {
    params.set("filters", filterBy);
  }
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_models?${params.toString()}`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const createVehicleModel = async (
  customer,
  brand,
  model,
  version,
  image,
  type,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_models`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        brand,
        model,
        version,
        images: image ? [image] : [],
        vehicle_type_name: type,
      },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const updateVehicleModel = async (
  vehicleModelId,
  customer,
  brand,
  model,
  version,
  image,
  type,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "put",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_models/${vehicleModelId}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        brand,
        model,
        version,
        images: image ? [image] : [],
        vehicle_type_name: type,
      },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const deleteVehicleModel = async (customer, vehicleModelId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_models/${vehicleModelId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e?.response?.data?.details };
  }
};
